import { type AuthUser } from 'wasp/auth';
import DefaultLayout from '../layout/DefaultLayout';
import { useRedirectHomeUnlessUserIsAdmin } from '../useRedirectHomeUnlessUserIsAdmin';

const AdminUsagePage = ({ user }: { user: AuthUser }) => {
  useRedirectHomeUnlessUserIsAdmin({ user })

  return (
    <DefaultLayout user={user}>
       View your remaining quote here.
    </DefaultLayout>
  );
};

export default AdminUsagePage;
